import React from 'react';

import useMultiLanguageRegisterCategory from '../../RegisterCategory/hook/useMultiLanguageRegisterCategory';
import { ButtonDelete, ButtonOkStyle, FormFooterWrapper } from './styled';
import { ButtonStyle } from '../styled';

const FormFooterSubmit = ({
  textOk,
  textCancel,
  textDelete,
  onCancel,
  onFinish,
  onDelete,
  isDelete,
  isLoading,
  isDisable,
  isLoadingSubmit,
  isDisableDelete,
}) => {
  const { APPLICATION_REGISTERCATEGORY_BUTTON_DELETE } =
    useMultiLanguageRegisterCategory();
  return (
    <FormFooterWrapper>
      <ButtonOkStyle
        type="primary"
        htmlType="submit"
        onClick={onFinish}
        loading={isLoading}
        disabled={isLoadingSubmit || isDisable}
      >
        {/*must have a span tag so there are no spaces between letters*/}
        <span> {textOk}</span>
      </ButtonOkStyle>
      {isDelete && (
        <ButtonDelete
          disabled={isDisable || isDisableDelete}
          onClick={onDelete}
          loading={isLoading}
        >
          {/*must have a span tag so there are no spaces between letters*/}
          <span>
            {' '}
            {textDelete ?? APPLICATION_REGISTERCATEGORY_BUTTON_DELETE}
          </span>
        </ButtonDelete>
      )}
      <ButtonStyle
        style={{ minWidth: 126 }}
        disabled={isDisable}
        onClick={onCancel}
      >
        {/*must have a span tag so there are no spaces between letters*/}
        <span> {textCancel}</span>
      </ButtonStyle>
    </FormFooterWrapper>
  );
};

export default FormFooterSubmit;
